import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider} from '@chakra-ui/react';
import './index.css';
import App from './App';

// Set dark mode by default
document.documentElement.classList.add('chakra-ui-dark');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);